import { Fragment } from 'react';

import DesktopNavigationItem from './components/DesktopNavigationItem';
import FooterNavItem from './components/FooterNavItem';
import FooterWrapper from './components/FooterWrapper';
import LegalFootnotes from './components/LegalFootNotes';
import MobileNavigationItem from './components/MobileNavigationItem';
import PaymentMethods from './components/PaymentMethods';

import { FooterProps } from '.';

const Footer = ({ type, navigationItems, legalLinks, paymentMethods }: FooterProps) => (
  <FooterWrapper className="bg-footer-bg break-before before:bg-footer-bg break-after after:bg-footer-bg text-footer-text relative">
    {type !== 'simple' && (
      <nav className="lg:pt-35 z-base pb-15 w-full pt-20 lg:pb-20">
        <ul className="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-6 sm:gap-x-6">
          {navigationItems?.map((navItem, i) => (
            <Fragment key={`${navItem.id}-${i}`}>
              <DesktopNavigationItem
                itemClassName="text-footer-nav"
                labelClassName="text-footer-nav"
                navItem={navItem}
              />
              <MobileNavigationItem
                isCollapsible={true}
                labelClassName="text-footer-nav"
                linkClassName="text-footer-nav"
                navItem={navItem}
                type="secondary"
              />
            </Fragment>
          ))}
        </ul>
      </nav>
    )}

    <div className="z-base bg-footer-bottom-bar break-before before:bg-footer-bottom-bar break-after after:bg-footer-bottom-bar text-footer-bottom-bar-text relative flex flex-col gap-4 py-6 after:z-10 md:flex-row md:items-center md:justify-between">
      {paymentMethods && <PaymentMethods paymentMethods={paymentMethods} />}
      <LegalFootnotes>
        <FooterNavItem>© {new Date().getFullYear()} BOSS paints</FooterNavItem>
        {legalLinks?.map((link, i) => {
          return (
            <li className="inline" key={`${link.id}-${i}`}>
              <span> | </span>
              <FooterNavItem className="hover:underline" link={link.href}>
                {link.label}
              </FooterNavItem>
            </li>
          );
        })}
      </LegalFootnotes>
    </div>
  </FooterWrapper>
);

export default Footer;
